<ng-container *ngIf="!this.hideContent">
  <tr class="text-muted font-xs by-group-title">
    <td colspan="4">{{orderLine.name}}</td>
  </tr>

  <ng-container *ngFor="let product of products">
    <ng-container *ngIf="product.state !== ORDER_LINE_STATES.DELETED">
      <tr *ngIf="product?.details.picture">
        <td colspan="4" class="details-picture-td">
          <img [src]="product?.details.picture | multiImage: 'smallUrl' : true : ''" [alt]="product.name">
        </td>
      </tr>

      <tr class="by-group-products order-line-status-wrap">
        <td>
          <div class="d-flex justify-content-between">
            <div>{{product.name}}</div>

            <ui-order-line-status-badge
              *ngIf="product.state"
              [status]="product.state"
            ></ui-order-line-status-badge>
          </div>
        </td>
        <td class="text-center valign-top">{{product.quantity}}</td>

        <ng-container *ngIf="!simplifyView">
          <td class="text-center valign-top">{{product.price | currencyFormat: currency}}</td>
          <td class="text-end valign-top">{{product.total | currencyFormat: currency}}</td>
        </ng-container>
      </tr>
    </ng-container>

  </ng-container>
</ng-container>
